import { render, staticRenderFns } from "./ImgSwiperV5.vue?vue&type=template&id=5f11e4ac&scoped=true&"
import script from "./ImgSwiperV5.vue?vue&type=script&lang=js&"
export * from "./ImgSwiperV5.vue?vue&type=script&lang=js&"
import style0 from "./ImgSwiperV5.vue?vue&type=style&index=0&id=5f11e4ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11e4ac",
  null
  
)

export default component.exports